import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { CommonalityItem, CommonalityValueType } from '@/types/commonality';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../../requestOptions';

export type GlobalCommonalityUpsertBody = Readonly<{
  channel_name?: string;
  global_set_id?: number;
  commonality_key: string;
  default_value_type: CommonalityValueType;
  default_value: string;
  fallback_value_type?: CommonalityValueType | null;
  fallback_value?: string | null;
  grouping_id?: number | null;
  enabled?: boolean;
  strict_create?: boolean;
}>;

export type GlobalCommonalityUpsertData = Readonly<{
  commonality: CommonalityItem;
  id: number;
  was_created: boolean;
  // Decorate fan-out runs asynchronously on the SPC worker pool — see postGlobalCommonalityBulk.
  decorate_fanout_enqueued: boolean;
  decorate_affected_subscriptions: number;
}>;

type GlobalCommonalityUpsertResponse = Readonly<{
  data: GlobalCommonalityUpsertData;
}>;

export async function postGlobalCommonality(
  scope: RequestScope,
  args: { body: GlobalCommonalityUpsertBody },
  options: WriteRequestOptions
): Promise<ChannelApiResponse<GlobalCommonalityUpsertData>> {
  try {
    const res = await scopedChannelApi(scope).post<GlobalCommonalityUpsertResponse>('atts/commonality/global', args.body, {
      ...options,
      headers: buildAsturHeaders(),
    });

    if (!res.data?.data) {
      throw new Error('Invalid global commonality upsert response');
    }

    return {
      data: res.data.data,
      status: res.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
